import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  updateStudentData,
  updateStudentPayment,
} from "../../utilities/const/functions";
import classes from "./AllAttendanceReport.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  backgroundColor: "#F4F7FB",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: "80%",
  overflowY: "scroll",
};

const initData = {
  droppedReason: "",
  droppedDate: new Date(),
  dropped: true,
};
const AllAttendanceReportRemarksModal = ({ data, setAdd, admissionData }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const handleOpen = () => {
    console.log({ admissionData });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      const res = await updateStudentPayment({
        ...admissionData,
        message: message,
      });
      if (!res.error) {
        handleClose();
        setAdd((p) => !p);
      } else {
        window.alert(res.message);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setMessage(admissionData?.message);
    return () => {
      setMessage("");
    };
  }, [data, open]);

  return (
    <div>
      <Box onClick={handleOpen} sx={{ cursor: "pointer" }}>
        Message
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            sx={{ color: "#242424", fontSize: "18px", fontWeight: 600 }}
          >
            Message
          </Typography>

          <TextField
            multiline
            minRows={4}
            name="droppedReason"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            value={message}
            sx={{ width: "100%", mt: "20px", backgroundColor: "#fff" }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "30px" }}>
            <Button
              onClick={handleClose}
              sx={{
                // borderRadius: "6px",
                // padding: "5px 10px",
                marginRight: 2,
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              sx={{
                color: "#fff",
                backgroundColor: (theme) => theme.palette.primary.main,
                padding: "5px 10px",
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.primary.main,
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default AllAttendanceReportRemarksModal;
